import React from "react";
import { Helmet } from 'react-helmet-async';
import "../../../assets/styles/AnalyticsMarketing.css";
import analyticsHero from "../../../assets/images/analytics.jpg";
import analyticsDashboard from "../../../assets/images/Why-Marketing-Analytics.jpg";

const AnalyticsMarketingPage = () => {
  return (
    <div className="analytics-container">
      <Helmet>
        <title>Marketing Analytics – BuddyTech Solutions</title>
        <meta name="description" content="Unlock insights from your marketing efforts through real-time analytics, dashboards, and performance tracking." />
        <meta name="keywords" content="marketing analytics, data dashboards, campaign tracking, performance reports, Google Analytics, ROI measurement" />

        <meta property="og:title" content="Marketing Analytics – BuddyTech Solutions" />
        <meta property="og:description" content="Unlock insights from your marketing efforts through real-time analytics, dashboards, and performance tracking." />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/marketing/analytics" />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Marketing Analytics – BuddyTech Solutions" />
        <meta name="twitter:description" content="Unlock insights from your marketing efforts through real-time analytics, dashboards, and performance tracking." />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>

      <header className="analytics-hero">
        <div className="analytics-hero-content">
          <h1>Marketing Analytics</h1>
          <p>
            Make informed marketing decisions using our real-time dashboards, KPI tracking, and ROI-focused reporting solutions.
          </p>
        </div>
        <img src={analyticsHero} alt="Analytics Hero" className="analytics-hero-img" />
      </header>

      <section className="analytics-section">
        <div className="analytics-text">
          <h2>What We Provide</h2>
          <p>
            With tailored analytics dashboards, we help you understand your audience, optimize performance, and drive measurable results.
          </p>
          <ul>
            <li>Real-time Campaign Dashboards</li>
            <li>Google & Meta Ads Analytics</li>
            <li>Email & SEO Performance Reports</li>
            <li>Custom KPIs & Conversion Tracking</li>
            <li>Marketing Funnel Analysis</li>
          </ul>
        </div>
        <img src={analyticsDashboard} alt="Analytics Dashboard" className="analytics-img" />
      </section>

      <section className="analytics-tools">
        <h2>Tools & Platforms</h2>
        <div className="tools-grid">
          <span>Google Analytics</span>
          <span>Looker Studio</span>
          <span>Hotjar</span>
          <span>Meta Ads Manager</span>
          <span>Mixpanel</span>
          <span>Microsoft Clarity</span>
          <span>HubSpot Analytics</span>
          <span>Tableau</span>
        </div>
      </section>
      <section className="contact-options">
                <div className="contact-card email">
                    <h2>📧 Email</h2>
                    <p>Send us an email for inquiries, support or collaboration opportunities.</p>
                    <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
                        Send Email
                    </a>
                </div>

                <div className="contact-card whatsapp">
                    <h2>💬 WhatsApp</h2>
                    <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
                    <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
                        Chat on WhatsApp
                    </a>
                </div>

                <div className="contact-card phone">
                    <h2>📞 Call Us</h2>
                    <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
                    <a href="tel:+919842084312">Call Us</a>
                </div>
            </section>
    </div>
  );
};

export default AnalyticsMarketingPage;
